import Component from './Delete.vue';

export default {
  install(Vue) {
    Vue.component('BkfDialogEntityDelete', Component);
  },
};
